import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import useUser from "../hooks/useLogin";

// Landing por rol al entrar a "/". Los paths tienen que existir en root.jsx.
const HOME_BY_ROL = {
  "super administrador": "/proyectos",
  administrador: "/proyectos",
  contabilidad: "/ordenes-pago",
  cliente: "/proyectos",
  proveedor: "/proyectos",
  abogado: "/contratos",
};

const DEFAULT_HOME = "/proyectos";

export default function PrivateRoute() {
  const { token, user_rol } = useUser();
  const { pathname } = useLocation();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (pathname === "/") {
    return <Navigate to={HOME_BY_ROL[user_rol] || DEFAULT_HOME} replace />;
  }

  return <Outlet />;
}
